// extracted by mini-css-extract-plugin
export var Banner = "style-module--Banner--1AHea";
export var Card = "style-module--Card--xmHd-";
export var Category = "style-module--Category--7rkhy";
export var DescriptionWrapper = "style-module--DescriptionWrapper--X4Z6Q";
export var Details = "style-module--Details--W6Sx5";
export var Image = "style-module--Image--Q-EOT";
export var ImageWrapper = "style-module--ImageWrapper--UDAGh";
export var ReadingTime = "style-module--ReadingTime--oDks7";
export var Title = "style-module--Title--3nDZX";